var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9313 5.28646C16.6373 3.79697 15.8354 2.45572 14.6624 1.4918C13.4895 0.527894 12.0182 0.00112163 10.5 0.00146501C7.97125 0.00146501 5.775 1.43646 4.68125 3.53646C3.3952 3.67544 2.20588 4.28477 1.3418 5.24737C0.477725 6.20997 -0.000150239 7.45793 3.54312e-08 8.75146C3.54312e-08 11.6477 2.35375 14.0015 5.25 14.0015H16.625C19.04 14.0015 21 12.0415 21 9.62646C21 7.31646 19.2063 5.44396 16.9313 5.28646ZM12.25 7.87646V11.3765H8.75V7.87646H6.125L10.1937 3.80771C10.3687 3.63271 10.64 3.63271 10.815 3.80771L14.875 7.87646H12.25Z",
    fill: "#336699"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.9724ff93.svg";
export { ForwardRef as ReactComponent };